// test2699
(2699 && 0);
